// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"01ecc33f","437":"663617d8","453":"ab5a8b64","766":"22dc7c89"}[chunkId] + ".chunk.js";
};